var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54960)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9326 9.85141C26.8392 9.85035 25.7909 9.41555 25.0178 8.64241C24.2447 7.86928 23.8099 6.82099 23.8088 5.72762V0.00390662H5.38374C4.67683 0.00364393 3.97679 0.142653 3.32361 0.412993C2.67044 0.683332 2.07695 1.07971 1.577 1.57947C1.07704 2.07924 0.68045 2.6726 0.409867 3.32568C0.139285 3.97875 -4.88096e-08 4.67873 0 5.38564V37.828C0.00211998 39.2543 0.570331 40.6214 1.5798 41.629C2.58928 42.6366 3.95745 43.2023 5.38374 43.2017H27.5026C28.2094 43.2017 28.9092 43.0625 29.5621 42.7921C30.2151 42.5216 30.8084 42.1252 31.3081 41.6255C31.8078 41.1257 32.2042 40.5325 32.4747 39.8795C32.7452 39.2266 32.8844 38.5268 32.8844 37.82V9.85141H27.9326Z",
    fill: "#699F4D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8844 9.85141H27.9326C26.8393 9.85035 25.791 9.41555 25.0178 8.64241C24.2447 7.86928 23.8099 6.82099 23.8088 5.72762V0.00390625L32.8844 9.85141Z",
    fill: "#699F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7882 34.1222H11.7814C10.0076 34.1222 8.56958 35.5602 8.56958 37.334V44.7897C8.56958 46.5635 10.0076 48.0015 11.7814 48.0015H36.7882C38.562 48.0015 40 46.5635 40 44.7897V37.334C40 35.5602 38.562 34.1222 36.7882 34.1222Z",
    fill: "#699F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2694 42.6758V44.1297H12.7634V42.6758H14.2694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2008 38.116L21.7628 44.1297H19.9629L19.003 40.1059L18.033 44.1297H16.2331L14.7952 38.116H16.3771L17.1511 42.4718L18.207 38.116H19.8069L20.8629 42.4718L21.6448 38.116H23.2008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6925 43.0317H25.4366L25.0626 44.1297H23.5327L25.7326 38.158H27.4085L29.6084 44.1297H28.0605L27.6925 43.0317ZM27.3165 41.9258L26.5686 39.7159L25.8126 41.9258H27.3165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2986 38.116L32.7705 42.6418L34.2425 38.116H35.7984L33.7065 44.1297H31.8266L29.7427 38.116H31.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0447 26.3866H21.8448V17.535C21.8448 17.2385 21.727 16.9542 21.5174 16.7445C21.3077 16.5349 21.0234 16.4171 20.7269 16.4171H15.1272C14.8307 16.4171 14.5463 16.5349 14.3366 16.7445C14.127 16.9542 14.0092 17.2385 14.0092 17.535V26.3866H11.8193V16.7871C11.8193 16.1071 12.0895 15.455 12.5703 14.9741C13.0511 14.4933 13.7032 14.2232 14.3832 14.2232H21.4648C22.1448 14.2232 22.797 14.4933 23.2778 14.9741C23.7586 15.455 24.0287 16.1071 24.0287 16.7871L24.0447 26.3866Z",
    fill: "#699F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4489 28.9824C22.8826 28.9824 24.0448 27.8202 24.0448 26.3866C24.0448 24.9529 22.8826 23.7907 21.4489 23.7907C20.0152 23.7907 18.853 24.9529 18.853 26.3866C18.853 27.8202 20.0152 28.9824 21.4489 28.9824Z",
    fill: "#699F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4374 28.9824C12.8711 28.9824 14.0333 27.8202 14.0333 26.3866C14.0333 24.9529 12.8711 23.7907 11.4374 23.7907C10.0038 23.7907 8.84155 24.9529 8.84155 26.3866C8.84155 27.8202 10.0038 28.9824 11.4374 28.9824Z",
    fill: "#699F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 47.9976,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWav);
export default __webpack_public_path__ + "static/media/wav.2d8989c267646dfb2fb1db6027a95295.svg";
export { ForwardRef as ReactComponent };